import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AgGridService } from '../ag-grid.service';
import { DropdownModel } from 'src/app/shared/models/common.model';
import { SendDataServiceService } from '../../../services/send-data-service.service';

@Component({
  selector: 'app-text-renderer',
  templateUrl: './text-renderer.component.html',
  styleUrls: ['./text-renderer.component.scss']
})
export class TextRendererComponent implements ICellRendererAngularComp {
  params;
  isCursor: boolean = false;
  isCrossIcon: boolean = false;
  textPrimary: boolean = false;
  name: string;
  details:string;
  isAddressAvailable:boolean=false
  constructor(public agGridService: AgGridService,public sendDataServiceService: SendDataServiceService) {}
  ngOnInit(): void {}
  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    this.isAddressAvailable=this.params.isAddressAvailable??false;
    this.isCursor = this.params?.isCursor??false;
    this.textPrimary = this.params?.textPrimary??false;

    this.valueChange(params)
    if(this.params.showDetails){
      this.details = this.params?.data?.components.find((x)=>x.type == 'BODY');
    }
}
refresh(params: ICellRendererParams<any, any>): boolean {
  this.params = params;
  this.isCursor = this.params?.isCursor??false;
  this.textPrimary = this.params?.textPrimary??false;

 this.valueChange(params)
  return true;  
}

valueChange(params){
  
  const valuesOrFunction = params.colDef.cellEditorParams?.values;
    var values = typeof valuesOrFunction === 'function' ? valuesOrFunction() : valuesOrFunction;

    if(values == undefined){
      this.name = params.value ?? "NA";
      this.isCursor = this.params?.isCursor??false;
    }
    else{
      const selectedOption = values.find((option: any) => option.id === params.value?.toString());
      // this.name = selectedOption ? selectedOption.name : params.value;
      this.name = selectedOption ? selectedOption.name : '';
    }
}

  onClick(event: MouseEvent) {
    if (this.isCursor) {
      this.agGridService.triggerOnTextClick(this.params);
    }
  }

  onContextMenu(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.params.api.dispatchEvent({type: 'customCellContextMenu',value: this.params.value});
  }

checkIsAddressAvailable(params){

}
onCrossIconClicked(params): void {
  this.sendDataServiceService.triggerCrossIconClick(params);
}
}
